// V2.1A Step C — Progress card + KPI cumulativo
import React from 'react';
import { formatEuro } from './salApi';

const Bar = ({ maturedPct, authorizedPct }) => {
  const mp = Math.min(100, Math.max(0, maturedPct));
  const ap = Math.min(mp, Math.max(0, authorizedPct));
  return (
    <div className="w-full h-3 bg-neutral-200 rounded-full overflow-hidden relative" data-testid="sal-progress-bar">
      {/* Approvato (giallo -> verde chiaro) */}
      <div
        className="absolute top-0 left-0 h-full bg-emerald-500/70"
        style={{ width: `${mp}%` }}
      />
      {/* Autorizzato fattura (blu) sovrapposto */}
      <div
        className="absolute top-0 left-0 h-full bg-teal-600"
        style={{ width: `${ap}%` }}
      />
    </div>
  );
};

const KpiCell = ({ label, value, tone = 'text-neutral-900', testid }) => (
  <div className="flex flex-col gap-0.5" data-testid={testid}>
    <span className="text-[11px] uppercase tracking-wide text-neutral-500">{label}</span>
    <span className={`text-sm font-semibold ${tone}`}>{value}</span>
  </div>
);

const SubcontractSALProgress = ({ summary, warnings = [] }) => {
  if (!summary) return null;
  const {
    contract_total, matured, authorized, remaining, retention,
    matured_percent, authorized_percent, remaining_percent, overrun,
  } = summary;

  return (
    <div
      className="border border-neutral-200 bg-white rounded-lg p-4 space-y-3"
      data-testid="sal-progress-card"
    >
      <div className="flex items-baseline justify-between">
        <h3 className="text-sm font-semibold text-neutral-800">Avanzamento cumulativo Subappalto</h3>
        <span className="text-xs text-neutral-500">
          {matured_percent.toFixed(1)}% maturato · {authorized_percent.toFixed(1)}% autorizzato
        </span>
      </div>
      <Bar maturedPct={matured_percent} authorizedPct={authorized_percent} />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 pt-1">
        <KpiCell label="Contratto"       value={formatEuro(contract_total)} testid="sal-kpi-contract" />
        <KpiCell label="Maturato"        value={formatEuro(matured)}        tone="text-emerald-700" testid="sal-kpi-matured" />
        <KpiCell label="Autorizzato"     value={formatEuro(authorized)}     tone="text-teal-700"    testid="sal-kpi-authorized" />
        <KpiCell label="Ritenute cum."   value={formatEuro(retention)}      tone="text-amber-700"   testid="sal-kpi-retention" />
        <KpiCell label="Residuo"         value={formatEuro(remaining)}      tone={overrun ? 'text-rose-700' : 'text-neutral-700'} testid="sal-kpi-remaining" />
      </div>
      {overrun && (
        <div
          className="text-xs text-rose-700 bg-rose-50 border border-rose-200 rounded px-2 py-1"
          data-testid="sal-progress-warning-overrun"
        >
          Attenzione: SAL cumulato eccede l&apos;importo contrattuale.
        </div>
      )}
      {warnings.map((w, i) => (
        <div
          key={i}
          className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-1"
          data-testid={`sal-progress-warning-${w.code || i}`}
        >
          {w.message}
        </div>
      ))}
    </div>
  );
};

export default SubcontractSALProgress;
